import React, {useEffect} from "react"

interface PriceProps {
	value: string
	currency?: string
	fractionDigits: number
	discounted?: boolean
}

export default function Price(props: PriceProps) {
	const [power, setPower] = React.useState(2)
	const [currency, setCurrency] = React.useState("€")

	function getCountry() {
		setPower(props.fractionDigits)
		props.currency ? setCurrency(props.currency) : setCurrency("€")
	}
	useEffect(() => getCountry())

	let floatValue = Number.parseFloat(props.value)

	let formattedPrice = (floatValue / Math.pow(10, power)).toFixed(power)

	return props.discounted === true ? (
		<div style={{textDecorationLine: "line-through", color: "red"}}>
			{currency} {formattedPrice}
		</div>
	) : (
		<>
			{currency} {formattedPrice}
		</>
	)
}
